import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalService } from '../../../services/modal.service';
import { IMessengerConnector, Message } from '../../../types/all.type';

@Component({
  selector: 'app-message-wall',
  templateUrl: './message-wall.component.html',
  styleUrls: ['./message-wall.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageWallComponent implements OnInit {
  @Input() wall: any;
  @Input() message: Message;
  @Input() Service: IMessengerConnector;
  @Input() messagesContainer: HTMLDivElement;
  @Input() messageBody: HTMLDivElement;
  @Input() lvl = 1;
  constructor(private cd: ChangeDetectorRef, public modalService: ModalService) {}

  ngOnInit(): void {
    this.cd.detach();
    this.cd.detectChanges();
  }
  openDetailInfo(id, type = 'user') {
    this.modalService.openModal('ModalChatDetailComponent', {
      Service: this.Service,
      id,
      type
    });
  }
  intlFormat(num) {
    return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
  }
  makeFriendly(num) {
    if (num >= 1000000) return this.intlFormat(num / 1000000) + 'M';
    if (num >= 1000) return this.intlFormat(num / 1000) + 'k';
    return this.intlFormat(num);
  }
}
